<template>
	<div class="flow-empty-state-wrapper" :position="position">
		<Container
			direction="column"
			padding="0px 12px"
			align="center"
			align-self="center"
			:gap="24"
			:shrink="0"
			class="max-width-400"
		>
			<Pictogram v-if="icon && shape !== 'none'" :shape="shape" size="large">
				<Icon
					:name="computedIcon.name"
					:type="computedIcon.type"
					:size="computedIcon.size"
					:state="computedIcon.state"
					:effects="false"
					:color="computedIcon.color"
				/>
			</Pictogram>
			<Icon
				v-if="icon && shape === 'none'"
				:name="computedIcon.name"
				:type="computedIcon.type"
				:size="computedIcon.size"
				:state="computedIcon.state"
				:effects="false"
				:color="computedIcon.color"
			/>

			<Typography
				v-if="message"
				type="h2"
				weight="bold"
				color="dark"
				align="center"
				data-qa-empty-state-message
				>{{ message }}</Typography
			>
			<Typography v-if="subtitle" type="p1-para" align="center" data-qa-empty-state-subtitle>{{
				subtitle
			}}</Typography>
			<Button
				v-if="action"
				state="outlined"
				:full-width="false"
				data-qa-empty-state-action
				@click="$emit('actions')"
				>{{ action }}</Button
			>
		</Container>

		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";
import Pictogram from "../Pictogram/Pictogram";
import Typography from "../Typography/Typography";
import Container from "../Container/Container";
import Button from "../Button/Button";

export default defineComponent({
	name: "EmptyState",
	components: {
		Icon,
		Pictogram,
		Typography,
		Container,
		Button
	},
	props: {
		icon: {
			type: [Object, String],
			default: () => null
		},
		shape: {
			type: String,
			default: "default",
			validator(value) {
				return ["hexagon", "default", "squircle", "circle", "none"].includes(value);
			}
		},
		position: {
			type: String,
			default: "relative"
		},
		message: {
			type: String,
			default: ""
		},
		subtitle: {
			type: String,
			default: ""
		},
		action: {
			type: String,
			default: null
		}
	},
	computed: {
		computedIcon() {
			if (typeof this.icon === "string") {
				return {
					name: this.icon,
					type: "filled",
					size: "medium",
					state: "default",
					color: "default"
				};
			} else {
				return this.icon;
			}
		}
	}
});
</script>
<style lang="scss">
div.flow-empty-state-wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	align-self: center;
	height: 100%;
	width: 100%;
	gap: 24px;

	&[position="absolute"] {
		position: absolute;
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
	}

	> div.flow-empty-state-icon-wrapper {
		display: flex;
		height: 72px;
		width: 72px;
		align-items: center;
		justify-content: center;
		// background-color: var(--dashboard-element-light);
		border-radius: 36px;
		// margin-bottom: 50px;

		div.icon-container {
			position: relative;
			&:before {
				position: absolute;
				content: "";
				top: -16px;
				bottom: -16px;
				right: -16px;
				left: -16px;
				border-radius: 50%;
				background-color: var(--dashboard-element-light);
			}
		}
	}

	> .flow-empty-state-message {
		// width: 200px;
		text-align: center;
		margin-bottom: 8px;
		&:only-child {
			margin-bottom: 0px;
		}
	}

	.paragraph-1 {
		line-height: 24px;
	}
}
</style>
